import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

// Font auto-ospitati: la PWA deve funzionare offline e non dipendere da un CDN.
import "@fontsource-variable/fraunces/full.css"
import "@fontsource/ibm-plex-sans/400.css"
import "@fontsource/ibm-plex-sans/500.css"
import "@fontsource/ibm-plex-sans/600.css"
import "@fontsource/ibm-plex-sans/700.css"

import { registerSW } from "virtual:pwa-register"

import { App } from "./App"
import "./stili/base.css"

// Il service worker serve il guscio offline e l'installabilità. La coda dei
// voti non sta qui: vive in IndexedDB lato app, perché il replay in
// background (Background Sync) manca su Safari. Vedi stato/coda.ts.
registerSW({ immediate: true })

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
